/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module aggregating error types.
 * @module utilities/errors
 */
"use strict";

/** @requires utilities/errors/authentication */

var AuthenticationError = require("./authentication");

/** @requires utilities/errors/bidding */
var BiddingError = require("./bidding");

/** @requires utilities/errors/communication */
var CommunicationError = require("./communication");

/** @requires utilities/errors/database */
var DatabaseError = require("./database");

/** @requires utilities/errors/functions */
var FunctionCallError = require("./functions");

/** @requires utilities/errors/subscription */
var SubscriptionError = require("./subscription");

/** @requires utilities/errors/compareErrors */
var compareErrors = require("./compareErrors");

module.exports = {
  AuthenticationError: AuthenticationError,
  BiddingError: BiddingError,
  CommunicationError: CommunicationError,
  DatabaseError: DatabaseError,
  FunctionCallError: FunctionCallError,
  SubscriptionError: SubscriptionError,
  compareErrors: compareErrors
};


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/errors/index.js
// module id = 528
// module chunks = 6